import { Component, OnInit, Input, NgZone, ViewChild } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { FileUploader, FileUploaderOptions, ParsedResponseHeaders } from 'ng2-file-upload';
import 'rxjs/add/operator/toPromise';
import { Cloudinary } from '@cloudinary/angular-4.x';
import { ModalDirective } from 'ng2-bootstrap';
import { EntityrecordApi } from '../../../sdk/services/custom';
import { Entityrecord } from '../../../sdk/models';

import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'profile-photo-widget',
    templateUrl: 'profile-photo.component.html',
    providers: [EntityrecordApi],

})
export class ProfilePhotoComponent implements OnInit {

    @Input()
    responses: Array<any>;
    @Input() imageid: string;
    @Input() imageurl: string;
    @Input() appid: string;
    @Input() entityid: string;
    @Input() entityrecordid: string;
    @Input() recordname: string;
    subscriptions: any = [];
    ngUnsubscribe: Subject<any> = new Subject<any>();

    uploader: FileUploader;
    title: string;
    @ViewChild('editModal') public editModal: ModalDirective;

    constructor(
        private cloudinary: Cloudinary,
        private zone: NgZone,
        private _EntityrecordApi: EntityrecordApi
    ) {
        this.responses = [];
        this.title = '';
    }

    ngOnInit(): void {
        if (!this.imageurl) {
            this.imageurl = "https://res.cloudinary.com/ampcome/image/upload/v1507010792/default-profile.jpg";
        }
        // Create the file uploader, wire it to upload to your account
        const uploaderOptions: FileUploaderOptions = {
            url: `https://api.cloudinary.com/v1_1/${this.cloudinary.config().cloud_name}/upload`,
            // Upload files automatically upon addition to upload queue
            autoUpload: true,
            // Use xhrTransport in favor of iframeTransport
            isHTML5: true,
            // Calculate progress independently for each uploaded file
            removeAfterUpload: true,
            // XHR request headers
            headers: [
                {
                    name: 'X-Requested-With',
                    value: 'XMLHttpRequest'
                }
            ]
        };
        this.uploader = new FileUploader(uploaderOptions);

        this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
            var folder = "";
            folder = this.appid + "/" + this.entityid + "/";

            // Add Cloudinary's unsigned upload preset to the upload form
            form.append('upload_preset', this.cloudinary.config().upload_preset);
            // Add built-in and custom tags for displaying the uploaded photo in the list
            let tags = this.appid + "," + this.entityid;
            if (this.title) {
                form.append('context', `photo=${this.title}`);
            }
            form.append('tags', tags);
            form.append('folder', folder);
            form.append('file', fileItem);

            // Use default "withCredentials" value for CORS requests
            fileItem.withCredentials = false;
            return { fileItem, form };
        };

        // Insert or update an entry in the responses array
        const upsertResponse = fileItem => {

            // Run the update in a custom zone since for some reason change detection isn't performed
            // as part of the XHR request to upload the files.
            // Running in a custom zone forces change detection
            this.zone.run(() => {
                // Update an existing entry if it's upload hasn't completed yet

                // Find the id of an existing item
                const existingId = this.responses.reduce((prev, current, index) => {
                    if (current.file.name === fileItem.file.name && !current.status) {
                        return index;
                    }
                    return prev;
                }, -1);
                if (existingId > -1) {
                    // Update existing item with new data
                    this.responses[existingId] = Object.assign(this.responses[existingId], fileItem);
                } else {
                    // Create new response
                    this.responses.push(fileItem);
                }





            });
        };

        // Update model on completion of uploading a file
        this.uploader.onCompleteItem = (item: any, response: string, status: number) => {

            /*
            Check if the file has been uploaded successfully and update the entity record with the secure url of the image
            */
            if (status === 200) {
                this.patchOrCreateEntity(JSON.parse(response));
            } else {
                //Let the user know that the upload has failed and ask them to upload again
                console.log('Upload failed');
            }
            upsertResponse(
                {
                    file: item.file,
                    status,
                    data: JSON.parse(response)
                }

            );
        }



        // Update model on upload progress event
        this.uploader.onProgressItem = (fileItem: any, progress: any) =>
            upsertResponse(
                {
                    file: fileItem.file,
                    progress,
                    data: {}
                }
            );
    }

    updateTitle(value: string) {
        this.title = value;
    }

    // Delete an uploaded image
    // Requires setting "Return delete token" to "Yes" in your upload preset configuration
    // See also https://support.cloudinary.com/hc/en-us/articles/202521132-How-to-delete-an-image-from-the-client-side-
    deleteImage = function (data: any, index: number) {
        const url = `https://api.cloudinary.com/v1_1/${this.cloudinary.config().cloud_name}/delete_by_token`;
        let headers = new Headers({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' });
        let options = new RequestOptions({ headers: headers });
        const body = {
            token: data.delete_token
        };
        this.http.post(url, body, options)
            .toPromise()
            .then((response) => {
                console.log(`Deleted image - ${data.public_id} ${response.json().result}`);
                // Remove deleted item for responses
                this.responses.splice(index, 1);
            }).catch((err: any) => {
                console.log(`Failed to delete image ${data.public_id} ${err}`);
            });
    };

    fileOverBase(e: any): void {
    }

    getFileProperties(fileProperties: any) {
        // Transforms Javascript Object to an iterable to be used by *ngFor
        if (!fileProperties) {
            return null;
        }
        return Object.keys(fileProperties)
            .map((key) => ({ 'key': key, 'value': fileProperties[key] }));
    }

    public showEditModal(): void {
        this.editModal.show();
    }

    public hideEditModal(): void {
        this.editModal.hide();
    }

    patchOrCreateEntity(cdresponse): void {
        let entityrecordid = this.entityrecordid;

        //Get the entityrecord and save it again
        this._EntityrecordApi.findById(this.entityrecordid).map((res: Entityrecord) => res)
            .subscribe((data) => {
                var record = data;
                record["data"]["imageurl"] = cdresponse.secure_url;
                this.subscriptions.push(this._EntityrecordApi.patchAttributes(entityrecordid, record)
                    .takeUntil(this.ngUnsubscribe)
                    .subscribe(() => {
                        //Close the modal
                        this.hideEditModal();
                    }));

            },
            err => err.message
            );


    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        for (let i = 0; i < this.subscriptions.length; i++) { this.subscriptions[i].unsubscribe(); }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/profile-photo/profile-photo.component.ts